import { searchCustomers } from "./../../../services/sales/customer";

import { arrayPushOrUpdateByID } from './../../../utils/toolkit';
 
export default {
    namespaced: true,
    state: {
        list: [],
        loading: false,
    },
    getters:{
        loading: state => state.loading ,
        list: state => state.list
    },
    mutations:{
        setLoading : (state, payload) =>   state.loading = payload,
        push : (state, payload) =>  state.list = arrayPushOrUpdateByID(state.list, payload)
    },
    actions: {
        get(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                searchCustomers({search: payload})
                    .then(response => {
                        context.commit("push", response.data);
                        resolve(response)
                    })
                    .catch(error => reject(error))
                    .finally(() => {
                        context.commit("setLoading", false);
                    });
            });
        },
        push(context, payload) {
            context.commit("push", [payload]);
        }
    }
}